import request from "@/utils/request";

// ---------------------电子发票-蓝票-----------------
// 待开票列表
export function getElectronicBlueWaitingList(params) {
  return request({
    url: "/invoice/standby/electronic_ticket/general",
    method: "get",
    params,
  });
}

// 开票
export function createElectronicBlueInvoice(data) {
  return request({
    url: "/invoicing/electronic_ticket/general",
    method: "post",
    data,
  });
}

// 开票记录列表
export function getElectronicBlueRecordList(params) {
  return request({
    url: "/invoice/history/electronic_ticket/general",
    method: "get",
    params,
  });
}

// 刷新开票失败状态记录
export function refreshElectronicBlueStatus(params) {
  return request({
    url: "/invoice/refresh/electronic_ticket/general",
    method: "get",
    params,
  });
}

// ---------------------电子发票-红票-----------------
// 待开票列表
export function getElectronicRedWaitingList(params) {
  return request({
    url: "/invoice/standby/electronic_ticket/red",
    method: "get",
    params,
  });
}

// 开票
export function createElectronicRedInvoice(data) {
  return request({
    url: "/invoicing/electronic_ticket/red",
    method: "post",
    data,
  });
}

// 开票记录列表
export function getElectronicRedRecordList(params) {
  return request({
    url: "/invoice/history/electronic_ticket/red",
    method: "get",
    params,
  });
}

// 刷新开票失败状态记录
export function refreshElectronicRedStatus(params) {
  return request({
    url: "/invoice/refresh/electronic_ticket/red",
    method: "get",
    params,
  });
}

// ---------------------纸质发票-蓝票-----------------
// 待开票列表
export function getPaperBlueWaitingList(params) {
  return request({
    url: "/invoice/standby/paper_ticket/general",
    method: "get",
    params,
  });
}

// 开票
export function createPaperBlueInvoice(data) {
  return request({
    url: "/invoicing/paper_ticket/general",
    method: "post",
    data,
  });
}

// 开票记录列表
export function getPaperBlueRecordList(params) {
  return request({
    url: "/invoice/history/paper_ticket/general",
    method: "get",
    params,
  });
}

// 刷新开票失败状态记录
export function refreshPaperBlueStatus(params) {
  return request({
    url: "/invoice/refresh/paper_ticket/general",
    method: "get",
    params,
  });
}

// ---------------------纸质发票-红字普票-----------------
// 待开票列表
export function getPaperRedGeneralWaitingList(params) {
  return request({
    url: "/invoice/standby/paper_ticket/red/general",
    method: "get",
    params,
  });
}

// 开票
export function createPaperRedGeneralInvoice(data) {
  return request({
    url: "/invoicing/paper_ticket/red/general",
    method: "post",
    data,
  });
}

// 开票记录列表
export function getPaperRedGeneralRecordList(params) {
  return request({
    url: "/invoice/history/paper_ticket/red/general",
    method: "get",
    params,
  });
}

// 刷新开票失败状态记录
export function refreshPaperRedGeneralStatus(params) {
  return request({
    url: "/invoice/refresh/paper_ticket/red/general",
    method: "get",
    params,
  });
}

// ---------------------纸质发票-红字专票-----------------
// 待开票列表
export function getPaperRedSpecialWaitingList(params) {
  return request({
    url: "/invoice/standby/paper_ticket/red/special",
    method: "get",
    params,
  });
}

// 开票
export function createPaperRedSpecialInvoice(data) {
  return request({
    url: "/invoicing/paper_ticket/red/special",
    method: "post",
    data,
  });
}

// 开票记录列表
export function getPaperRedSpecialRecordList(params) {
  return request({
    url: "/invoice/history/paper_ticket/red/special",
    method: "get",
    params,
  });
}

// 刷新开票失败状态记录
export function refreshPaperRedSpecialStatus(params) {
  return request({
    url: "/invoice/refresh/paper_ticket/red/special",
    method: "get",
    params,
  });
}

// 纸质发票作废
export function invalidPaperInvoice(data) {
  return request({
    url: "/invoicing/invalid",
    method: "post",
    data,
  });
}
